<div class="hmn-unit-details-header-controls-month hmn-padding__x2-horiz hmn-row__space">
  <mat-icon
    (click)="onLeftClick()"
    class="hmn-color__accent hmn-cursor__pointer">
    arrow_left
  </mat-icon>

  <p class="hmn-color__accent hmn-margin__x6-horiz">{{ getMonthOfYearLabel() | translate | titlecase }}</p>

  <mat-icon
    (click)="onRightClick()"
    class="hmn-color__accent hmn-cursor__pointer">
    arrow_right
  </mat-icon>
</div>
